import { SystemUpdateAltOutlined } from '@mui/icons-material'

import Routes from '@tabeeb/routes'
import { getShowBulkImport } from '@tabeeb/modules/bulkImports/selectors'
import { useSelector } from '@tabeeb/store'
import { NavbarItem } from '@collaborate-health/uikit'

const BulkImportTab: React.FC = () => {
  const display = useSelector(getShowBulkImport)
  if (!display) {
    return null
  }

  return <NavbarItem name='Bulk import' href={Routes.bulkImports} icon={<SystemUpdateAltOutlined />} />
}

export default BulkImportTab

